import { getActiveBrand } from "./activeBrand";

/**
 * Apply brand-specific values to the document <head> before render: page title,
 * favicon, browser theme-color, and the PWA manifest link. `index.html` ships
 * with neutral defaults; this swaps them for the active deployment brand.
 *
 * Call this once at startup (from `index.tsx`), before React mounts.
 */
export function applyBrandHead(): void {
  const brand = getActiveBrand();

  document.title = brand.displayName;

  setLinkHref("icon", brand.favicon);
  if (brand.appleTouchIcon) {
    setLinkHref("apple-touch-icon", brand.appleTouchIcon);
  }
  setLinkHref("manifest", brand.manifest);
  setMetaContent("theme-color", brand.themeColor);
  setMetaContent("description", brand.displayName);
}

function setLinkHref(rel: string, href: string): void {
  let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement("link");
    link.rel = rel;
    document.head.appendChild(link);
  }
  link.href = href;
}

function setMetaContent(name: string, content: string): void {
  let meta = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = name;
    document.head.appendChild(meta);
  }
  meta.content = content;
}
